import { render } from "./TableContent.vue?vue&type=template&id=6bef1375"
import script from "./TableContent.vue?vue&type=script&lang=ts"
export * from "./TableContent.vue?vue&type=script&lang=ts"
script.render = render

export default script